module.exports = __webpack_public_path__ + "static/img/xgyf1.842dcf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/xgyf1.png
// module id = 394
// module chunks = 0